import { ChangeDetectionStrategy, Component, Injector, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { ITaskV2 } from '@fi-app/task-v2/fi-task-v2';
import { Subject } from 'rxjs';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FiTaskPriorityType } from '@fi-app/task-v2/fi-task-v2-enums';
import { FiTaskV2HelperService } from '@fi-app/task-v2/fi-task-v2-helper.service';

@Component({
    selector: 'fi-task-v2-edit-priority',
    templateUrl: './fi-task-v2-edit-priority.component.html',
    styleUrl: './fi-task-v2-edit-priority.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-task-v2-edit-priority' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiTaskV2EditPriorityComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiTaskV2EditPriorityComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiTaskV2EditPriorityComponent
    extends ControlValueAccessorValidatorBase<FiTaskPriorityType>
    implements OnInit, OnDestroy
{
    ngOnDestroy$: Subject<void> = new Subject<void>();
    protected readonly PrioritiesList = [FiTaskPriorityType.Low, FiTaskPriorityType.Medium, FiTaskPriorityType.High];

    constructor(
        injector: Injector,
        private fiTaskV2HelperService: FiTaskV2HelperService,
    ) {
        super(injector);
    }

    ngOnInit() {}

    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    protected getPriorityTypeText(priorityType: FiTaskPriorityType) {
        return this.fiTaskV2HelperService.getPriorityTextByType(priorityType);
    }
}
